export class FileUploader {
	static Options = {};

	static Initialize(options) {
		this.Options = {
			MaximumSize: 10485760,
			AllowedExtensions: [], ...options
		};

		if (this.Options.Buttons?.length) {
			[...(typeof this.Options.Buttons === "string" ? document.querySelectorAll(this.Options.Buttons) : this.Options.Buttons)]
				.filter(x => x != null)
				.forEach(button => button.onclick = () => this.#GetFiles());
		}

		if (this.Options.DropAreas?.length) {
			((typeof this.Options.DropAreas === "string" ? document.querySelectorAll(this.Options.DropAreas) : this.Options.DropAreas))
				.forEach(area => {
					Object.assign(area ?? {}, {
						ondragenter: ev => ev.preventDefault(),
						ondragover: ev => ev.preventDefault(),
						ondrop: this.#OnDrop
					});
				});
		}
	}

	static #OnDrop = ev => {
		ev.preventDefault();

		const items = ev.dataTransfer.items,
			files = ev.dataTransfer.files;

		if (this.Options.DragDropMessage) {
			Dialog.ShowConfirmation("Are you sure?", this.Options.DragDropMessage).then(proceed => {
				if (!proceed) { return; }

				if (ev.dataTransfer.items?.length) {
					this.#ProcessFiles(Array.from(items).filter(x => x.kind === "file").map(y => y.getAsFile()));
				} else {
					this.#ProcessFiles(files);
				}
			});
		} else if (items) {
			this.#ProcessFiles(Array.from(items).filter(x => x.kind === "file").map(y => y.getAsFile()));
		} else {
			this.#ProcessFiles(files);
		}
	}

	static #GetDomLurker() {
		const lurker = document.createElementWithContents("input", "", {
			type: "file",
			accept: this.Options.AllowedExtensions.map(x => `.${x}`).join(",")
		});

		if (this.Options.Multiple) {
			lurker.setAttribute("multiple", "");
		}

		if (this.Options.IsDirectory) {
			Object.assign(lurker, {
				directory: "",
				webkitdirectory: "",
				multiple: ""
			});
		}

		return lurker;
	}

	static async #ProcessFiles(receivedFiles) {
		const files = [];

		return new Promise(res => {
			if (receivedFiles.length) {
				const reader = new FileReader();
				let index = 0;

				const mapper = new Promise(resolve => {
					reader.onload = async () => {
						const file = Object.assign(receivedFiles[index], {
							getData: () => btoa(new Uint8Array(reader.result).reduce((data, byte) => data + String.fromCharCode(byte), ''))
						});

						if (!this.Options.AllowedExtensions.length || this.Options.AllowedExtensions.includes(file.name.split(".").pop())) {
							if (file.size <= this.Options.MaximumSize || this.Options.MaximumSize < 1) {
								files.push(file);
							} else if (typeof this.Options.OnFileTooLarge === "function") {
								await this.Options.OnFileTooLarge(file);
							}
						}

						if (index < receivedFiles.length - 1) {
							reader.readAsArrayBuffer(receivedFiles[++index]);
						} else {
							resolve();
						}
					}
				});

				reader.readAsArrayBuffer(receivedFiles[0]);

				mapper.then(() => {
					this.Options.OnComplete?.(files);

					res(files);
				});
			}
		});
	}

	static #GetFiles() {
		if (this.Options.onCheckValid?.() === false) { return; }

		const domLurker = this.#GetDomLurker();

		return new Promise(res => {
			if (domLurker) {
				domLurker.onchange = async () => {
					const files = await this.#ProcessFiles(domLurker.files);

					res(files);
				}

				domLurker.click();
			}
		});
	}
}